// src/components/HomeScreen.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';

const HomeScreen = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate('/name');
  };

  return (
    <div>
      <Header />
      <div className = "center flex flex-col items-center h-screen">

     
      <div className="flex flex-col items-center justify-center w-full h-screen gap-12 ">
        <h5 className='text-xl md:text-5xl text-[#0D3C26] text-center'>Personalized learning delivered <br></br>to your inbox Every Day.</h5>
       
        <button className="button text-base md:text-xl max-w-96" onClick={handleNext}>Next</button>
      </div>
      </div>
    </div>
  );
};

export default HomeScreen;
